import React from 'react';
import ChaptersContext from '../ChaptersContext';

export default function ChaptersProvider(props) {
  const { value, children } = props;
  return <ChaptersContext.Provider value={value}>{children}</ChaptersContext.Provider>;
}
